import React from "react";

import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import "../../../css/admin/comments.scss";
import videoPlaceholder from "../../../resources/video_placeholder.jpg";
import { getImageFromPictures } from "../../../utils/data/Content";
import Button from "../../button/Button";

import type { JSX } from "react";

import type { AppState } from "../../../reducers";
import type { CommentSource } from "../comment.types";

interface SourceThreadProps {
  source: CommentSource;
}

function SourceThread({ source }: SourceThreadProps): JSX.Element {
  const { t } = useTranslation("editor-comments");
  const { project } = useSelector(
    (state: AppState) => state.architectureReducer,
  );

  const image =
    getImageFromPictures(source.pictures, "169", source.type) ??
    videoPlaceholder;

  return (
    <div className="editor-source-thread-container">
      <div
        className="source-image"
        style={{ backgroundImage: `url(${image})` }}
      >
        {!image && <i className="material-icons">content</i>}
      </div>
      <div className="source-label">{source.label}</div>
      <Button
        isFullWidth
        size="sm"
        type="button"
        onClick={() =>
          window.open(
            `${project?.base_url}/${source.sourceType}/${source.uuid}`,
            "_blank",
          )
        }
      >
        {t("goToDiscussion")}
      </Button>
    </div>
  );
}

export default SourceThread;
